export function useOverrideState<T>(defaultState: T): { state: ComputedRef<T>, useState: (newOverrideState: Partial<T>) => ComputedRef<T> } {
  const state = defaultState
  const overrideState = ref<Partial<T> | undefined>()

  const newState = computed(() => {
    return { ...state, ...(overrideState.value ?? {}) }
  })

  function useState(newOverrideState: Partial<T>): ComputedRef<T> {
    overrideState.value = newOverrideState

    onUnmounted(() => {
      overrideState.value = undefined
    })

    return newState
  }

  return {
    state: newState,
    useState,
  }
}
